export default function ProgressRing({
  percent = 0,
  size = 64,
  stroke = 6,
  showLabel = true,
  label,
  className = "",
}) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const offset = circ - (Math.min(100, Math.max(0, percent)) / 100) * circ;
  const filled = percent > 0;
  return (
    <div className={`relative inline-flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="rgba(255,255,255,0.08)"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="var(--gold)"
          strokeWidth={stroke}
          strokeDasharray={circ}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{
            transition: "stroke-dashoffset 0.9s cubic-bezier(0.22,1,0.36,1)",
            filter: filled ? "drop-shadow(0 0 6px rgba(212,175,55,0.6))" : "none",
          }}
        />
      </svg>
      {showLabel && (
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-heading font-bold text-foreground" style={{ fontSize: size * 0.26 }}>
            {Math.round(percent)}%
          </span>
          {label && <span className="text-[9px] uppercase tracking-widest text-muted-foreground">{label}</span>}
        </div>
      )}
    </div>
  );
}
